export default {
    carousel: {
        skip: 'skip',
        next: 'next',
        item1: {
            title: 'Use your initial budget properly',
            subtitle:
                'to invest in the resources you will need during a F1 <br>racing season. Think carefully about their maintenance<br> requirements and the optimal way of operating them'
        },
        item2: {
            title: 'Experience the key decisions',
            subtitle: 'that a racing team manager has to take at each stage<br> of the asset life-cycle in a total of {{seasons}} seasons of {{races}} races'
        },
        item3: {
            title: 'Develop AM 4.0 capabilities',
            subtitle: 'to obtain data-driven lenses and improve your decision- <br> making process, gaining a competitive advantage'
        }
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/onboarding.js